<template>
	<div class="app--engagement-popup" :class="classes" :title="$t('app.common.close')" @click="close">
		<div class="header">
			<button class="close"><app-icon value="close"></app-icon></button>
			<div v-if="logo" class="logo"><img :src="logo" class="rounded-circle"></div>
		</div>
		<div class="content">
			<div v-html="popup"></div>
		</div>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
		page: { type: Object, required: true }
	},
	computed: {
		logo() {
			if (store.state.info.user.logo && store.state.theme.popup.image) {
				return store.state.info.user.logo
			}
			if (store.state.info.company.logo && store.state.theme.popup.logo) {
				return store.state.info.company.logo
			}

			return false
		},
		popup() {
			return (this.logo ? this.spacer : '') + store.getters['macro'](this.page.description)
		},
		classes() {
			let c = [
				'text--color-' + store.state.theme.popup.color,
				'text--font-' + store.state.theme.popup.font,
				'text--size-' + store.state.theme.popup.size,
			];
			if (this.active) { c.push('active') }
			return c
		},
	},
	data() {
		return { active: false, spacer: '<div class="spacer"></div>' }
	},
	mounted() {
		this.active = true
	},
	beforeUnmount() {
		this.close()
	},
	methods: {
		close() {
			this.active = false
			setTimeout(() => { store.commit('REMOVE_POPUP', this.page.id) }, 500)
		}
	},
}
</script>
